module.exports = __webpack_public_path__ + "resources/img/img_datahunt3_jp.093dd2b44fc417eac61f5ebb24df3460.png";